import {Component} from '@angular/core';
import {DmUploadComponent} from "../../upload/dm-upload.component";

interface DmUploadDocumentFile {
    name: string;
    objectURL: string;
}

// <!-- DEPRECATRED -->

@Component({
    selector: 'mvs-dm-upload-consultant',
    templateUrl: './dm-upload-consultant.component.html',
    styleUrls: ['./dm-upload-consultant.component.scss'],
    standalone: false,
})
export class DmUploadConsultantComponent extends DmUploadComponent{

   ngOnInit() {
        super.ngOnInit();
   }

}
